import type { HTMLAttributes } from 'react';
import { cn } from '../lib/utils';

export type RefreshIconProps = HTMLAttributes<SVGElement> & {
  spinning?: boolean;
};

export function RefreshIcon({ spinning = false, className, ...props }: RefreshIconProps) {
  return (
    <svg
      aria-hidden
      viewBox="0 0 24 24"
      className={cn('size-icon-sm', spinning && 'animate-spin', className)}
      fill="none"
      stroke="currentColor"
      strokeWidth="1.75"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      <path d="M21 12a9 9 0 0 0-15.5-6.4L3 8" />
      <path d="M3 3v5h5" />
      <path d="M3 12a9 9 0 0 0 15.5 6.4L21 16" />
      <path d="M21 21v-5h-5" />
    </svg>
  );
}
